<div
  class="tile"
  [routerLink]="['/', routesNames.productDetails, product?.code] | localize"
>
  <img
    class="product__image"
    [src]="product?.image + PresentationConstants.imagePrefix.desktop.productDetail"
    [alt]="product?.name + ' image'"
  />
  <div class="tile-right-part">
    <div class="product__info">
      <p class="product__code">
        {{ "product_tile.reference_abbreviation" | translate }}
        {{ product?.code }}
      </p>
      <p class="product__name">{{ product?.name ?? "" }}</p>
      <p class="product__units">
        {{
          "product_tile.box_of_n_units"
            | translate: { quantity: product?.units ?? 0 }
        }}
      </p>
    </div>

    <div class="row">
      <div class="bottom-part-info">
        <div *ngIf="canDisplayPrices$ | async">
          <div class="row row--prices">
            <p class="product__price old-promotion__price" *ngIf="product?.priceWithoutPromo !== null">
              {{ product?.priceWithoutPromo | localizedCurrency }}
            </p>
            <p class="product__price" *ngIf="product?.price != 0; else free">
              {{ product?.price | localizedCurrency }}
            </p>
            <ng-template #free>
              <p class="product__price">
                {{ "product_tile.promotion.free_product" | translate }}
              </p>
            </ng-template>
          </div>
          <div class="row row--prices">
            <p class="product__unit-price old-promotion__price" *ngIf="product?.unitPriceWithoutPromo !== null">
              {{ product?.unitPriceWithoutPromo | localizedCurrency }}
              {{ "product_tile.unit" | translate | lowercase }}
            </p>
            <p class="product__unit-price" *ngIf="product?.unitPrice">
              {{ product?.unitPrice | localizedCurrency }}
              {{ "product_tile.unit" | translate | lowercase }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <p class="product__quantity">{{ "x" + product?.quantity }}</p>
</div>
